export interface Volume {
  number: string;
  title: string;
  description: string;
  tag: string;
  coverImage: string;
}

export const volumes: Volume[] = [
  {
    number: '01',
    title: 'Mistrzowie ruchu',
    description: 'Rzeczy, które jeżdżą, wirują, wystrzeliwują w górę i trzymają równowagę.',
    tag: '24 karty · Łatwe → Wyzwanie',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/f759TGcrBYr4mLuZk6SGyz/young-inventor-lab-volume-01-motion-makers.webp',
  },
  {
    number: '02',
    title: 'Kartonowi inżynierowie',
    description:
      'Pudełka i rzeczy z recyklingu zamieniają się w sprytne konstrukcje i proste maszyny.',
    tag: '24 karty · Łatwe → Wyzwanie',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/3izzzjTZbg9RnfM8wR5CEi/young-inventor-lab-volume-02-cardboard-engineers.webp',
  },
  {
    number: '03',
    title: 'Prąd i proste obwody',
    description: 'Energia i pierwsze obwody elektryczne, poznawane w praktyce.',
    tag: '24 karty · Łatwe → Wyzwanie',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/j1aJNSgA3RNEN7rgmduJEK/young-inventor-lab-volume-03-power-simple-circuits.webp',
  },
  {
    number: '04',
    title: 'Nauka w akcji',
    description:
      'Testujcie, obserwujcie i odkrywajcie, jak działają siły i reakcje, które widzimy na co dzień.',
    tag: '24 karty · Łatwe → Wyzwanie',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/3qLMRPjgSBEZNFkLWqtKjs/young-inventor-lab-volume-04-science-in-action.webp',
  },
  {
    number: '05',
    title: 'Wielkie wyzwania',
    description: 'Otwarte zadania wynalazcze: zaplanuj, sprawdź, ulepsz i stwórz coś swojego.',
    tag: '24 karty · Łatwe → Wyzwanie',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/54mWdoZqkgQQ7c72aofmWR/young-inventor-lab-volume-05-big-idea-challenges.webp',
  },
];

export interface BuildCard {
  title: string;
  src: string;
  alt: string;
}

export const buildCards: BuildCard[] = [
  {
    title: 'Wyścigówka na balon',
    src: 'https://cdn.magicpatterns.com/uploads/9Zm4A2Zfs3rQBrMwvjB6Cx/01-wyscigowka-na-balon.webp',
    alt: 'Karta projektu: Wyścigówka na balon',
  },
  {
    title: 'Bateria z cytryn',
    src: 'https://cdn.magicpatterns.com/uploads/ojaMDdbne7LMvFLPikF7mL/02-bateria-z-cytryn.webp',
    alt: 'Karta projektu: Bateria z cytryn',
  },
  {
    title: 'Wulkan z sody i octu',
    src: 'https://cdn.magicpatterns.com/uploads/gXJmg86NZhkkTetRZQHExt/03-wulkan-z-sody-i-octu.webp',
    alt: 'Karta projektu: Wulkan z sody i octu',
  },
  {
    title: 'Zamek z mostem zwodzonym',
    src: 'https://cdn.magicpatterns.com/uploads/3Hqfav8nzS9i5vK19mbiur/04-zamek-z-mostem-zwodzonym.webp',
    alt: 'Karta projektu: Zamek z mostem zwodzonym',
  },
  {
    title: 'Latarnia morska z butelki',
    src: 'https://cdn.magicpatterns.com/uploads/aY6VWwLCstKjXesWmaWXgR/05-latarnia-morska-z-butelki.webp',
    alt: 'Karta projektu: Latarnia morska z butelki',
  },
  {
    title: 'Lawa w butelce',
    src: 'https://cdn.magicpatterns.com/uploads/2xuUGmM6sAEwYWjuDxmQjN/06-lawa-w-butelce.webp',
    alt: 'Karta projektu: Lawa w butelce',
  },
  {
    title: 'Ramię hydrauliczne',
    src: 'https://cdn.magicpatterns.com/uploads/mUzv6J2M3f85SH4sJs7GwK/07-ramie-hydrauliczne.webp',
    alt: 'Karta projektu: Ramię hydrauliczne',
  },
  {
    title: 'Maszyna w 10 krokach',
    src: 'https://cdn.magicpatterns.com/uploads/27x34y1nyq2wZgwf5Q3YRC/08-maszyna-w-10-krokach.webp',
    alt: 'Karta projektu: Maszyna w 10 krokach',
  },
];

export interface Bonus {
  badge: string;
  title: string;
  description: string;
}

export const bonuses: Bonus[] = [
  {
    badge: 'BONUS 1',
    title: '7 dni na dobry start',
    description: 'Siedem gotowych dni majsterkowania. Zaczynacie od razu, bez planowania.',
  },
  {
    badge: 'BONUS 2',
    title: 'Czym to zastąpić?',
    description:
      'Ściąga ze sprytnymi zamiennikami na chwile, gdy w domu brakuje akurat tej jednej rzeczy.',
  },
  {
    badge: 'BONUS 3',
    title: 'Karty ratunkowe',
    description:
      'Szybkie podpowiedzi, co zrobić, gdy coś nie działa. Wpadka zamienia się w kolejny dobry pomysł.',
  },
  {
    badge: 'BONUS 4',
    title: 'Misje na podwórku',
    description:
      '12 wynalazczych misji na świeżym powietrzu i dziennik odkrywcy do wydrukowania.',
  },
  {
    badge: 'BONUS 5',
    title: '52 tygodnie ciekawości',
    description:
      '52 zadania STEM, jedno na każdy tydzień, i plakat na cały rok do powieszenia na ścianie.',
  },
];

export interface ProofPoint {
  title: string;
  description: string;
}

export const proofPoints: ProofPoint[] = [
  {
    title: 'Wszystko jasne od początku',
    description:
      'Wiek, czas, poziom trudności i potrzebna pomoc dorosłego są widoczne, zanim zaczniecie.',
  },
  {
    title: 'Dla prawdziwych domów',
    description:
      'Każdy projekt zaczyna się od rzeczy, które znacie i łatwo znajdziecie w szafkach.',
  },
  {
    title: 'Prawdziwy efekt',
    description:
      'Dziecko robi coś, co jeździ, wiruje, startuje, trzyma równowagę albo rozwiązuje zadanie.',
  },
  {
    title: 'Miejsce na rozwój',
    description: 'Łatwe → Z podpowiedzią → Wyzwanie. Pewność siebie rośnie razem z ciekawością.',
  },
  {
    title: 'Coś więcej niż zamiennik ekranu',
    description: 'Każdy projekt zachęca, żeby wymyślać, testować, ulepszać i próbować jeszcze raz.',
  },
];

export interface Faq {
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    question: 'Co dokładnie dostanę?',
    answer:
      'Od razu po zakupie dostajesz dostęp do wszystkich pięciu tomów do wydrukowania, czyli 120 obrazkowych kart projektów, a do tego Mapę projektów, Dziennik Małego Wynalazcy i wszystkie pięć bonusów.',
  },
  {
    question: 'Czy to fizyczny zestaw STEM?',
    answer:
      'Nie. To produkt cyfrowy: pliki PDF, które drukujesz w domu. Nic nie przychodzi pocztą, a do projektów wystarczą zwykłe rzeczy, które macie pod ręką.',
  },
  {
    question: 'Dla dzieci w jakim wieku?',
    answer:
      'Dla dzieci w wieku 5–12 lat. Na każdej karcie zaznaczony jest wiek. Młodsze dzieci zaczynają od projektów „Łatwych”, starsze szybko sięgają po „Wyzwania”.',
  },
  {
    question: 'Jakie materiały będą potrzebne?',
    answer:
      'Głównie to, co zwykle ląduje w koszu albo leży w szufladzie: tektura, rolki po ręcznikach papierowych, butelki, nakrętki, balony, słomki, taśma klejąca, spinacze i folia aluminiowa. Pełna lista jest na każdej karcie. Brakuje czegoś? Zajrzyj do ściągi „Czym to zastąpić?”.',
  },
  {
    question: 'Jak działają poziomy trudności?',
    answer:
      'W każdym tomie projekty idą od „Łatwych”, przez „Z podpowiedzią”, aż po „Wyzwania”. Dziecko zaczyna od szybkich sukcesów, a z każdą kartą robi coraz więcej samo.',
  },
  {
    question: 'Czy przy każdym projekcie muszę pomagać?',
    answer:
      'Nie. Na karcie widzisz, ile pomocy dorosłego potrzeba: małej, średniej albo dużej. Starsze dzieci wiele projektów zrobią samodzielnie. Młodszym przydasz się głównie przy cięciu i na starcie.',
  },
  {
    question: 'Czy mogę używać kart w edukacji domowej albo w szkole?',
    answer:
      'Tak. Licencja obejmuje użytek domowy, edukację domową i jedną klasę, czyli jednego nauczyciela i jego uczniów. Karty świetnie sprawdzają się na zajęciach z techniki, przyrody i na świetlicy.',
  },
  {
    question: 'Czy to subskrypcja?',
    answer: 'Nie. Płacisz raz 73 zł i nie ma żadnych kolejnych opłat.',
  },
  {
    question: 'Jak dostanę pliki?',
    answer:
      'Zaraz po płatności dostaniesz e-mail z linkiem do pobrania. Pliki otworzysz na komputerze, tablecie albo telefonie i wydrukujesz na zwykłej drukarce, w formacie A4.',
  },
  {
    question: 'Czy projekty są bezpieczne?',
    answer:
      'Każda karta ma wskazówki dotyczące bezpieczeństwa i jasno pokazuje, kiedy potrzebny jest dorosły, na przykład przy ostrych nożyczkach albo balonach u młodszych dzieci. Tam, gdzie jest to zaznaczone, zalecamy nadzór osoby dorosłej.',
  },
];
